import React, {Component} from 'react'
import {Route, Redirect} from 'react-router-dom'
import AdminCustomers from './AdminCustomers/AdminCustomers'
import AdminUsersGrid from './AdminUsers/AdminUsersGrid'
import AdminUserProfile from './AdminUsers/AdminUserProfile'
import VisualizationsGrid from './Visualizations/VisualizationsGrid'
import VisualizationView from './Visualizations/VisualizationView'
import VisualizationEdit from './Visualizations/VisualizationEdit'
import VisualizationNew from './Visualizations/VisualizationNew'
import DashboardsGrid from './Dashboards/DashboardsGrid'
import DashboardView from './Dashboards/DashboardView'
import Header from './Shared/Header'
import Footer from './Shared/Footer'
import ResourcesExample from './Resources/ResourcesExample'
import ResourcesFaq from './Resources/ResourcesFaq'
import Home from './Home'
import MyProfile from './User/MyProfile'
import ChangePassword from './User/ChangePassword'
import Signout from './Shared/Signout'
import LogIn from './Shared/LogIn'
import Sidebar from './Shared/Sidebar'
//import ForgotPassword from './Shared/ForgotPassword'
import ForgotPasswordConfirmation from './Shared/ForgotPasswordConfirmation'
//import AdminUserChangePassword from './AdminUsers/AdminUserChangePassword'
import AdminSecurityRolesGrid from './AdminSecurityRoles/AdminSecurityRolesGrid'
import AdminSecurityRoleProfile from './AdminSecurityRoles/AdminSecurityRoleProfile'
import AdminBusinessDivisionsGrid from './AdminBusinessDivisions/AdminBusinessDivisionsGrid'
import AdminBusinessDivisionProfile from './AdminBusinessDivisions/AdminBusinessDivisionProfile'
//import ForgotPasswordConfirm from './Shared/ForgotPasswordConfirmation'
import * as config from './Configuration/Config'
import UserProfile from './Configuration/UserProfile'
import CustomWorkspace from './CW/cw'
import FoldersGrid from './CW/folders/FoldersGrid'
import FoldersProfile from './CW/folders/FoldersProfile'


import ChapterTest from './Chapter/chaptertest'
import Tree from './tree/tree'
import Imp from './Imp/imp'
import Frame from './Frame/frame'

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={props =>
        config.AuthManager.isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
  
const HomeComponents = () => <div>
                                <Header title="Home" />
                                
                                
                                <Home {...this.props} /> 
                                <Footer />
                            </div>
const MyProfileComponents = () => <div>
                                <Header title="My Profile" />                                

                                <MyProfile {...this.props} /> 
                                <Footer />
                            </div>
const VisualizationsGridComponents = (params) => <div>
                                                <Header title="Visualizations" />
                                                
                                                
                                                <VisualizationsGrid {...this.props} {...params} /> 
                                                <Footer />
                                            </div>
const VisualizationViewComponents = (params) => <div>
                                                <Header  title="View Vizualization"/>
                                                
                                                
                                                <VisualizationView {...this.props} {...params} /> 
                                                <Footer />
                                            </div>

const VisualizationEditComponents = (params) => <div>
                                                <Header  title="Edit Vizualization"/>
                                                
                                                
                                                <VisualizationEdit {...this.props} {...params} /> 
                                                <Footer />
                                            </div>

const VisualizationNewComponents = (params) => <div>
                                                <Header  title="New Vizualization"/>
                                               

                                                <VisualizationNew {...this.props} {...params} /> 
                                                <Footer />
                                                </div>                                            

const DashboardsGridComponents = (params) => <div>
                                                <Header  title="Dashboards"/>
                                                
                                                
                                                <DashboardsGrid {...this.props} {...params} /> 
                                                <Footer />
                                            </div>
const DashboardViewComponents = (params) => <div>
                                                <Header title="View Dashboard" />
                                                
                                                
                                                <DashboardView {...this.props} {...params} /> 
                                                <Footer />
                                            </div>
const ResourcesExampleComponents = () =>   <div>
                                        <Header  title="Examples"/>
                                       
                                        
                                        <ResourcesExample {...this.props} /> 
                                        <Footer />
                                    </div>
const ResourcesFaqComponents = () =>   <div>
                                            <Header  title="Frequently Asked Questions"/>
                                            

                                            <ResourcesFaq {...this.props} /> 
                                            <Footer />
                                        </div>
const CustomerComponents = (params) =>    <div>
                                        <Header  title="Customers"/>
                                        
                                        
                                        <AdminCustomers {...this.props} {...params} /> 
                                        <Footer />
                                    </div>
const UsersGridComponents = (params) => <div>
                                        <Header  title="Users"/>
                                        
                                        
                                        <AdminUsersGrid {...this.props} {...params}/> 
                                        <Footer />
                                    </div>
const UserProfileComponents = (params) => <div>
                                            <Header  title="User Profile"/>
                                            
                                            
                                            <AdminUserProfile {...this.props} {...params}/> 
                                            <Footer />
                                        </div>
// const AdminUserChangePasswordComponents = (params) => <div>
//                                                         <Header  title="Change User Password"/>
//                                                         <Sidebar/>

//                                                         <AdminUserChangePassword {...this.props} {...params}/> 
//                                                         <Footer />
//                                                     </div>
const AdminSecurityRolesGridComponents = (params) => <div>
                                                        <Header  title="Security Roles"/>
                                                        

                                                        <AdminSecurityRolesGrid {...this.props} {...params}/> 
                                                        <Footer />
                                                    </div>
const AdminSecurityRoleProfileComponents = (params) => <div>
                                                        <Header  title="Security Role"/>
                                                        

                                                        <AdminSecurityRoleProfile {...this.props} {...params}/> 
                                                        <Footer />
                                                    </div>
const AdminBusinessDivisionsGridComponents = (params) => <div>
                                                        <Header  title="Business Divisions"/>
                                                        

                                                        <AdminBusinessDivisionsGrid {...this.props} {...params}/> 
                                                        <Footer />
                                                    </div>
const AdminBusinessDivisionProfileComponents = (params) => <div>
                                                            <Header  title="Business Division"/>
                                                            

                                                            <AdminBusinessDivisionProfile {...this.props} {...params}/> 
                                                            <Footer />
                                                        </div>
const ChangePasswordComponents = (params) => <div>
                                                                <Header  title="Change Password"/>
                                                                

                                                                <ChangePassword {...this.props} {...params}/> 
                                                                <Footer />
                                                            </div>
const ForgotPasswordConfirmationComponents = (params) => <div>
                                                {/* <Header  title="Forgot Password"/>
                                                <Sidebar/> */}

                                                <ForgotPasswordConfirmation {...this.props} {...params}/> 
                                                <Footer />
                                            </div>
const CustomWorkspaceComponents = () =>   
    <div>
    <Header  title="myAcumen"/>
    {/*<Sidebar/>*/}
    <CustomWorkspace {...this.props} /> 
    <Footer />
    </div>

const FoldersGridComponents = (params) => 
<div>
<Header  title="Folders"/>
<FoldersGrid {...this.props} {...params}/> 
<Footer />
</div>

const FoldersProfileComponents = (params) => 
<div>
<Header  title="Folders"/>
<FoldersProfile {...this.props} {...params}/> 
<Footer />
</div>

const ChapterTestComponents = () => 
    <div>
    <Header  title="Chapter"/>
    {/*<Sidebar/>*/}
    <ChapterTest {...this.props} /> 
    <Footer />
    </div>

const TreeComponents = (params) => 
    <div>
    <Header  title="Tree Test"/>
    {/*<Sidebar/>*/}
    <Tree {...this.props} {...params} /> 
    <Footer />
    </div>

const ImpComponents = (params) => 
<div>
<Imp {...this.props} {...params}/> 
</div>

const FrameComponents = (params) => 
<div> 
<Frame {...this.props} {...params}/>
</div>

class Main extends Component {
    constructor(){
        super()

        this.state = {
            is_loaded: false
        }
    }
    componentDidMount() {
        
        if (config.AuthManager.isAuthenticated()) {
            var p = new UserProfile();
            p.loadData(null,
                ()=>{
                    this.setState({is_loaded: true});
                }
            );
        } else {
            this.setState({is_loaded: true});
        }
    }
    render() {
        if (this.state.is_loaded === false) {
            return null;
        }

        return <div>

            <Route exact path="/login" render = {(params) => (
                <LogIn {...this.props} {...params} /> 
                )}
            />

            <Route exact path="/password/forgot" component={ForgotPasswordConfirmationComponents} />
            
            {/* <Route exact path="/login/forgot" render = {(params) => (
                <ForgotPassword {...this.props} {...params} /> 
                )}
            />
            <Route exact path="/login/forgot/confirm" render = {(params) => (
                <ForgotPasswordConfirmation {...this.props} {...params} /> 
                )}
            /> */}

            <PrivateRoute exact path="/" component={HomeComponents} />
            <PrivateRoute exact path="/dashboards" component={DashboardsGridComponents} />
            <PrivateRoute exact path="/dashboards/view/:did/:gid" component={DashboardViewComponents} />
            <PrivateRoute exact path="/visualizations" component={VisualizationsGridComponents} />
            <PrivateRoute exact path="/visualizations/view/:rid/:gid" component={VisualizationViewComponents} />
            <PrivateRoute exact path="/visualizations/edit/:rid/:gid" component={VisualizationEditComponents} />
            <PrivateRoute exact path="/visualizations/new/:did/:gid" component={VisualizationNewComponents} />
            <PrivateRoute exact path="/resources/example" component={ResourcesExampleComponents} />
            <PrivateRoute exact path="/resources/faq" component={ResourcesFaqComponents} />
            <PrivateRoute exact path="/admin/customers/:id?" component={CustomerComponents} />
            <PrivateRoute exact path="/admin/users/:cid" component={UsersGridComponents} />
            <PrivateRoute exact path="/admin/users/:cid/profile/:uid" component={UserProfileComponents} />
            {/* <PrivateRoute exact path="/admin/users/:cid/profile/:uid/password" component={AdminUserChangePasswordComponents} /> */}
            <PrivateRoute exact path="/admin/security/roles/:cid" component={AdminSecurityRolesGridComponents} />
            <PrivateRoute exact path="/admin/security/roles/:cid/:id" component={AdminSecurityRoleProfileComponents} />
            <PrivateRoute exact path="/admin/business/divisions/:cid" component={AdminBusinessDivisionsGridComponents} />
            <PrivateRoute exact path="/admin/business/divisions/:cid/:id" component={AdminBusinessDivisionProfileComponents} />
            <PrivateRoute exact path="/profile" component={MyProfileComponents} />
            <PrivateRoute exact path="/profile/password/change" component={ChangePasswordComponents} />
            <PrivateRoute exact path="/signout" component={Signout} />
            <PrivateRoute exact path="/cw" component={CustomWorkspaceComponents} />

            <PrivateRoute exact path="/cw/folders/:cid" component={FoldersGridComponents} />
            <PrivateRoute exact path="/cw/folders/:cid/:id" component={FoldersProfileComponents} />

            <PrivateRoute exact path="/chptest" component={ChapterTestComponents} />
            <PrivateRoute exact path="/tree" component={TreeComponents} />

            <Route exact path="/imp" component={ImpComponents} />
            <Route exact path="/frame/:rid/:gid" component={FrameComponents} />
        </div>
    }
}

export default Main


// WEBPACK FOOTER //
// ./src/Components/Main.js